import React from 'react';
import classNames from 'classnames';
import SparklesIcon from 'icons/Sparkles.icon';
import { Button } from 'ncoded-component-library';
import { Trans, useTranslation } from 'react-i18next';
import { getIsNotNewFeature } from 'utils';

import './DiscoveryFeatureCard.styles.scss';
import './DiscoveryFeatureCard.styles.responsive.scss';

export type DiscoveryFeatureCardProps = {
  className?: string;
  createdAt?: Date | string;
  title: string;
  description: string;
  descriptionValues?: Record<string, string>;
  primaryActionLabel?: string;
  onPrimaryAction?: () => void;
  onUnderstood?: () => void;
};

const DiscoveryFeatureCard: React.FC<DiscoveryFeatureCardProps> = (props) => {
  const {
    className,
    createdAt,
    title,
    description,
    descriptionValues,
    primaryActionLabel,
    onPrimaryAction,
    onUnderstood,
  } = props;

  const classes = classNames('discovery-feature-card', className);

  const { t } = useTranslation();

  if (getIsNotNewFeature(createdAt)) return null;

  return (
    <div className={classes}>
      <div className="discovery-feature-card__header">
        <div className="icon-badge">
          <SparklesIcon />
        </div>

        <p className="title">{title}</p>
      </div>

      <div className="discovery-feature-card__content">
        <p className="description">
          <Trans
            i18nKey={description}
            values={descriptionValues}
            components={{
              b: <b />,
            }}
          />
        </p>

        {(onUnderstood || onPrimaryAction) && (
          <div className="actions">
            {onUnderstood && (
              <Button variant="outline" onClick={onUnderstood}>
                {t('understood')}
              </Button>
            )}

            {onPrimaryAction && (
              <Button onClick={onPrimaryAction}>{primaryActionLabel}</Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DiscoveryFeatureCard;
